import { Box, Button, Container, Grid, Switch } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { useContext, useEffect, useState, useRef } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import RichTextEditor from 'react-rte';
import { CreateRegionValidationSchema } from '../../utils/Validations';
import { postRequest, putRequestWithToken } from '../../utils/ApiRequests';
import { GlobalContext } from '../../components/GlobalStateProvide/GlobalStateProvider';
import FocusError from '../../components/FocusError/FocusError';
import ReusableLoader from "../../components/ReusableLoader/ReusableLoader";
import BackBtn from '../../components/backButton/BackBtn';
import { checkPermission } from '../../utils/userPermissions'
import Unauthorized from "../../components/unauthorized/Unauthorized";

const CreateRegion = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const { handleSnackBar } = useContext(GlobalContext);
  const location = useLocation();

  const [dataById, setDataById] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const [canCreate, setCanCreate] = useState(true);
  const [canDelete, setCanDelete] = useState(true);
  const [canUpdate, setCanUpdate] = useState(true);
  const [canRead, setCanRead] = useState(true);
  const [isAccess, setisAccess] = useState([]);
  const [jobCount, setJobCount] = useState(0);
  const [isIncludesValue, setisIncludesValue] = useState(true);
  const [contentError, setContentError] = useState(false);

  const [sector, setSector] = useState([]);
  // const [fetchingPincode, setfetchingPincode] = useState(false);
  const [editorValue, setEditorValue] = useState(RichTextEditor.createEmptyValue());


  const [initialValues, setInitialValues] = useState({
    name: "",
    isActive: true,
    coordinates: ""
  })
  const [edit, setEdit] = useState(false);

  // console.log(location, "this is location");


  const scrollTargetRef = useRef(null);
  const navigate = useNavigate();


  const handleSubmit = async (values, { resetForm }) => {

    setContentError(false);
    setFormSubmitted(true);

    // Parse coordinates from JSON textarea
    let parsedCoordinates;
    let isMultiPolygon = false;

    try {
      parsedCoordinates = JSON.parse(values.coordinates);

      // Validate that it's an array
      if (!Array.isArray(parsedCoordinates)) {
        throw new Error("Coordinates must be an array");
      }

      // Determine format:
      // Single Polygon: [[lng, lat], [lng, lat], ...]
      // MultiPolygon: [[[[lng, lat], ...]], [[[lng, lat], ...]]]

      if (parsedCoordinates.length > 0 && Array.isArray(parsedCoordinates[0])) {
        if (Array.isArray(parsedCoordinates[0][0])) {
          // Check if it has rings layer (MultiPolygon format)
          if (Array.isArray(parsedCoordinates[0][0][0])) {
            // MultiPolygon format with rings: [[[[lng, lat], ...]], ...]
            isMultiPolygon = true;

            // Validate each polygon
            parsedCoordinates.forEach((polygon, polyIndex) => {
              if (!Array.isArray(polygon)) {
                throw new Error(`Polygon at index ${polyIndex} must be an array`);
              }
              if (polygon.length < 1) {
                throw new Error(`Polygon at index ${polyIndex} must have at least one ring`);
              }
              polygon.forEach((ring, ringIndex) => {
                if (!Array.isArray(ring)) {
                  throw new Error(`Ring at index ${ringIndex} in polygon ${polyIndex} must be an array`);
                }
                if (ring.length < 4) {
                  throw new Error(`Ring at index ${ringIndex} in polygon ${polyIndex} must have at least 4 coordinate pairs`);
                }
                ring.forEach((coord, coordIndex) => {
                  if (!Array.isArray(coord) || coord.length !== 2) {
                    throw new Error(`Coordinate at position ${coordIndex} in ring ${ringIndex} of polygon ${polyIndex} must be [longitude, latitude]`);
                  }
                  if (typeof coord[0] !== 'number' || typeof coord[1] !== 'number') {
                    throw new Error(`Coordinate at position ${coordIndex} in ring ${ringIndex} of polygon ${polyIndex} must contain numbers`);
                  }
                });
              });
            });
          } else {
            // Single Polygon format: [[lng, lat], [lng, lat], ...]
            parsedCoordinates.forEach((coord, index) => {
              if (!Array.isArray(coord) || coord.length !== 2) {
                throw new Error(`Coordinate at index ${index} must be an array of 2 numbers [longitude, latitude]`);
              }
              if (typeof coord[0] !== 'number' || typeof coord[1] !== 'number') {
                throw new Error(`Coordinate at index ${index} must contain numbers`);
              }
            });
          }
        }
      }

    } catch (err) {
      setFormSubmitted(false);
      handleSnackBar(true, `Invalid coordinates format: ${err.message}`, "error");
      return;
    }

    let formData = {
      name: values.name,
      polygon: isMultiPolygon ? {
        type: "MultiPolygon",
        coordinates: parsedCoordinates
      } : {
        type: "Polygon",
        coordinates: [parsedCoordinates]
      },
      isActive: values.isActive,
      metadata: {}
    };

    try {
      let res = edit ?
        await putRequestWithToken(`admin/regions/${dataById._id}`, formData) :
        await postRequest('admin/regions', formData);

      if (res.data.status === 'Success' || res.status === 201 || res.status === 200) {
        setFormSubmitted(false);
        if (!edit) {
          resetForm();
          handleSnackBar(true, res.data.msg || "Region created successfully", "success");
          setTimeout(() => {
            navigate('/regions');
          }, 1000);
        }
        else {
          handleSnackBar(true, res.data.msg || "Region updated successfully", "success");
          setTimeout(() => {
            navigate('/regions');
          }, 1000);
        }
      }
      else {
        setFormSubmitted(false);
        handleSnackBar(true, res.data.msg, "error")
      }
    } catch (err) {
      console.log(err);
      setFormSubmitted(false);
      handleSnackBar(true, err?.response?.data?.msg || err?.message, "error")
    }
  }

  const getEmployerById = async () => {
    setDataById(location.state)
  }

  const checkPermissionFunc = () => {
    const resourceToUpdate = "Plus-tech";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate)
    setCanDelete(permissions.canDelete)
    setCanUpdate(permissions.canUpdate)
    setCanRead(permissions.canRead)
  }

  const againCheckPermissions = () => {
    // console.log("hello")
    const checkAccesInArray = localStorage.getItem("resourceNames");
    // console.log("resourceNames : " + checkAccesInArray);
    setisAccess(checkAccesInArray);
    isIncludes();
  }

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes("Plus-tech"))
  }

  useEffect(() => {

    checkPermissionFunc();
    againCheckPermissions();
    if (location.state?._id) {
      getEmployerById()
    }
    else {
      setShowLoader(false);
    }

    if (location?.state?._id) {
      const { name = dataById?.name, isActive = true, polygon = {} } = dataById;

      // Handle both Polygon and MultiPolygon formats
      let coordinates;
      if (polygon.type === "MultiPolygon") {
        // MultiPolygon format - coordinates is already an array of polygons
        coordinates = polygon?.coordinates || [];
      } else {
        // Polygon format - coordinates[0] is the polygon
        coordinates = polygon?.coordinates?.[0] || [];
      }

      // Format coordinates as JSON string for textarea
      const coordinatesJSON = JSON.stringify(coordinates, null, 4);

      setInitialValues({
        name,
        isActive,
        coordinates: coordinatesJSON
      });
      setEdit(true);
    } else {
      setInitialValues({
        name: "",
        isActive: true,
        coordinates: ""
      });
      setEdit(false);
    }
  }, [location.state, dataById._id, isIncludesValue, sector])

  // const regionUserMarkers = useMemo(() => {
  //   const users = regionUserCountData?.users || [];
  //   return users
  //     .map((user) => {
  //       const coordinates = user?.location?.coordinates;
  //       if (!coordinates || coordinates.length !== 2) {
  //         return null;
  //       }
  //       const [lng, lat] = coordinates;
  //       return { id: user._id, position: [lat, lng] };
  //     })
  //     .filter(Boolean);
  // }, [regionUserCountData]);




  return (
    <>
      {(isIncludesValue) ? <>
        {showLoader ? <ReusableLoader /> : <Box className="create-employer-section" ref={scrollTargetRef}>

          <Container>

            <Box className="create-employer">
              <Box className="headingPlusBackBtn">
                <BackBtn />
                <h1 className='formHeadings'>{edit ? "Update Region" : "Create Region"}</h1>
              </Box>
              <Box className="create-employer-form-wrapper">
                <Formik
                  initialValues={initialValues}
                  validationSchema={CreateRegionValidationSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({ errors, values, setFieldValue, resetForm, touched, setFieldTouched }) => (

                    <Form className="create-employer-form ">
                      <Box className="backgroundStyle">
                        <Grid container spacing={2} className='cstmFormGridEmployer'>

                          <Grid item xs={12} sm={12} md={8}>
                            <Box className="form-control" >
                              <label className="form-label" htmlFor="name"> Region Name <span className='must-fill-fields'>*</span></label>
                              <Field id="name"
                                type="text" placeholder="Enter Region Name"
                                name="name"
                                className="form-input" size="small"
                              />
                              {errors.name && <Box className="form-error">{errors.name}</Box>}

                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={12} md={8}>
                            <Box className="form-control" >
                              <label className="form-label" htmlFor="isActive"> IsActive <span className='must-fill-fields'>*</span></label>
                              <Switch
                                id="isActive"
                                name="isActive"
                                checked={values.isActive}
                                onChange={(event) => {
                                  setFieldValue("isActive", event.target.checked);
                                }}
                              />
                              {errors.isActive && <Box className="form-error">{errors.isActive}</Box>}

                            </Box>
                          </Grid>

                          {/* Coordinates Section */}

                          <Grid item xs={12} sm={12} md={7}>
                            <Box className="form-control">
                              <label className="form-label" htmlFor="coordinates"> Polygon Coordinates <span className='must-fill-fields'>*</span></label>

                              <Field
                                as="textarea"
                                id="coordinates"
                                name="coordinates"
                                placeholder='Enter coordinates in JSON format'
                                className="form-input"
                                rows={30}
                                style={{
                                  width: "100%",
                                  fontFamily: "monospace",
                                  fontSize: "0.9rem",
                                  resize: "vertical"
                                }}
                              />
                              {errors.coordinates && touched.coordinates && (
                                <Box className="form-error">{errors.coordinates}</Box>
                              )}
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={12} md={5}>

                            <Box sx={{ fontSize: "0.85rem", color: "#666", mb: 2 }}>
                              Enter coordinates as a JSON array. Supports both single polygon and multiple polygons.
                              <br />
                              <strong>Single Polygon:</strong> [[longitude, latitude], ...]
                              <pre style={{ fontSize: "0.75rem", marginTop: "8px", padding: "8px", backgroundColor: "#f5f5f5", borderRadius: "4px" }}>
                                {`[
        [
            75.7831421,
            26.8237032
        ],
        [
            75.8037414,
            26.8151263
        ],
        [
            75.7985916,
            26.7878596
        ],
        [
            75.7529297,
            26.7924555
        ],
        [
            75.7831421,
            26.8237032
        ]
    ]
`}
                              </pre>
                              <strong>Multiple Polygons (MultiPolygon):</strong> [[[[lng, lat], ...]], ...]
                              <pre style={{ fontSize: "0.75rem", marginTop: "8px", padding: "8px", backgroundColor: "#f5f5f5", borderRadius: "4px" }}>
                                {`[
    [
        [
            [
                76.1877135,
                27.0223648
            ],
            [
                76.1883627,
                27.021255
            ],
            [
                76.1869197,
                27.0204284
            ],
            [
                76.1855679,
                27.0212884
            ],
            [
                76.1863242,
                27.0227456
            ],
            [
                76.1877029,
                27.0223682
            ],
            [
                76.1877135,
                27.0223648
            ]
        ]
    ],
    [
        [
            [
                75.9656524,
                27.0386764
            ],
            [
                75.9951782,
                27.0117694
            ],
            [
                75.9677124,
                26.9582422
            ],
            [
                75.8945846,
                26.9759855
            ],
            [
                75.9275436,
                27.0212487
            ],
            [
                75.9656524,
                27.0386764
            ]
        ]
    ]
]`}
                              </pre>
                            </Box>
                          </Grid>

                        </Grid>

                      </Box>

                      <Box className="form-button-section">
                        <Link to='/regions'>
                          <Button className="form-button"
                            variant="contained"
                            onClick={() => {
                              resetForm();
                            }}
                            color="error"
                          >Cancel</Button>
                        </Link>

                        <Button className="form-button"
                          variant="contained"
                          type="submit"
                          color="success"
                          disabled={formSubmitted}
                        >
                          {formSubmitted ? <CircularProgress size={24} /> :
                            edit ? "Update" : "Create"}
                        </Button>

                      </Box>
                      <FocusError handleSnackBar={handleSnackBar} />
                    </Form>
                  )}
                </Formik>
              </Box>
            </Box>
          </Container>

        </Box >}
      </> : (<Unauthorized />)}

    </>
  )

}
export default CreateRegion;
